/**
 * Asynchronously loads the component for Batch
 */

import { lazyLoad } from 'utils/loadable';

export const AuthoriseBatch = lazyLoad(
  () => import('./index'),
  module => {
    return module.AuthoriseBatch;
  },
);
